import {
  Provider,
  Portal,
  Content,
  Root,
  Trigger,
  Arrow,
} from '@radix-ui/react-tooltip';
import { gtEstiPro } from '@trwl/app/fonts';
import cn from 'classnames';
import { PropsWithChildren, useState } from 'react';

export const InfoTooltip = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState(false);

  return (
    <Provider delayDuration={100}>
      <Root delayDuration={100} open={open} onOpenChange={setOpen}>
        <Trigger asChild onClick={() => setOpen(true)}>
          <span
            className={cn(
              'text-lg font-medium cursor-pointer text-[#B1B1B1]',
              gtEstiPro.className,
            )}
          >
            ?
          </span>
        </Trigger>
        <Portal>
          <Content
            className="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-violet11 select-none rounded-[4px] bg-white px-[15px] py-[10px] text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]"
            sideOffset={5}
          >
            {children}
            <Arrow className="fill-white" />
          </Content>
        </Portal>
      </Root>
    </Provider>
  );
};
